export enum LANG {
	ES = 'es',
	EN = 'en'
}